import { EventHandler, SyntheticEvent, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { audioPause, audioPlay, audioResume } from "../../store/modules/audio/actions";
import { getIsPaused, getIsPlaying, getSelectedVoice } from "../../store/modules/audio/selectors";

export const useTogglePlay = () => {
  // redux
  const selectedVoice = useSelector(getSelectedVoice);
  const isPlaying = useSelector(getIsPlaying);
  const isPaused = useSelector(getIsPaused);
  const dispatch = useDispatch();
  // callbacks
  const togglePlay = useCallback<EventHandler<SyntheticEvent>>((event) => {
    event.preventDefault();

    if (!isPlaying && !isPaused && selectedVoice) {
      dispatch(audioPlay(true));
    }

    if (isPlaying && !isPaused) {
      dispatch(audioPause());
    }

    if (!isPlaying && isPaused) {
      dispatch(audioResume());
    }
  }, [isPlaying, isPaused, selectedVoice, dispatch]);

  return ({
    isPlaying,
    togglePlay,
  });
};
